export default __webpack_public_path__ + "static/media/sf_4.b8a4488c.PNG";